var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c(
        "div",
        { staticClass: "presentations" },
        [
          _vm.data.items && _vm.data.items.length
            ? _c(
                "div",
                { staticClass: "row" },
                _vm._l(_vm.data.items, function (item, index) {
                  return _c("z-report-block", {
                    key: index,
                    staticClass: "col-default-4 col-v-tablet-6 col-mobile-12",
                    attrs: {
                      image: item.preview.link,
                      link: item.file.link,
                      title: item.name,
                      "title-period": item.year.value,
                      "landscape-mode": "",
                    },
                  })
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.data.groups && _vm.data.groups.length
            ? _c(
                "z-accordion",
                { staticClass: "u-top-margin--xl-important" },
                _vm._l(_vm.data.groups, function (accordion, i) {
                  return _c("z-accordion-item", {
                    key: i,
                    attrs: { id: accordion.code },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c("span", [_vm._v(_vm._s(accordion.name))]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "body",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "row" },
                                _vm._l(accordion.items, function (item, index) {
                                  return _c("z-report-block", {
                                    key: index,
                                    staticClass:
                                      "col-default-4 col-v-tablet-6 col-mobile-12",
                                    attrs: {
                                      image: item.preview.link,
                                      link: item.file.link,
                                      title: item.name,
                                      "title-period": item.year.value,
                                      "landscape-mode": "",
                                    },
                                  })
                                }),
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  })
                }),
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }